import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import AuthenticatedRoute from './AuthenticatedRoute';

import LicenseManager from './components/licenses/LicenseManager';
import { PaymentPage } from './components/payment/PaymentPage';
import { LoginPage } from './components/login/LoginPage';
import PurchasePage from './components/purchase/PurchasePage';
import AxiosHelper from './setupInterceptors.js';

import { AuthService } from './state/auth.service';

//setup the interceptor for 401s
AxiosHelper.setup();

class Routes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPayer: null,
    };

    this.checkIfPayer = this.checkIfPayer.bind(this);
  }

  componentDidMount() {
    this.checkIfPayer();
  }

  componentWillReceiveProps() {
    this.checkIfPayer();
  }

  async checkIfPayer() {
    const isPayer = await AuthService.isPayer();
    this.setState({ isPayer });
  }

  render() {
    const { isPayer } = this.state;
    return (
      <div className="router-outlet">
        <Route exact path="/account/signin" component={LoginPage} />
        <Route exact path="/purchase" component={PurchasePage} />
        <AuthenticatedRoute exact path="/" component={LicenseManager} isPayer={isPayer} />
        <AuthenticatedRoute exact path="/index.html" component={LicenseManager} isPayer={isPayer} />
        <AuthenticatedRoute exact path="/licenses" component={LicenseManager} isPayer={isPayer} />
        <AuthenticatedRoute exact path="/payment-info" component={PaymentPage} isPayer={isPayer} />
      </div>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js